export default {
    color: {
        textColor: "white",
        background: "#2b3743",
        chip: "#1b272F",
        mainBackground: "#202D36",
    }
}